import React from 'react';
import cx from 'classnames';
import styles from './Tabs.module.scss';
import { useTranslation } from 'react-i18next';
import useAccessibleClick from '../../../../../common/hooks/useAccessibleClick';

const Tabs = ({ state, onClick, isHideTeam }) => {
  const { t } = useTranslation();

  const videosTabRef = useAccessibleClick(() => onClick({ folders: false, team: false }));
  const foldersTabRef = useAccessibleClick(() => onClick({ folders: true }));
  const teamsTabRef = useAccessibleClick(() => onClick({ team: true }));

  return (
    <div className={styles.tabs}>
      <div
        ref={videosTabRef}
        className={cx(styles.tab, { [styles.tabActive]: !state?.folders && !state?.team })}
        onClick={() => onClick({ folders: false, team: false })}
        tabIndex={0}
      >
        {t('dashboard.videos.title')}
      </div>
      <div
        ref={foldersTabRef}
        tabIndex={0}
        className={cx(styles.tab, { [styles.tabActive]: state?.folders })}
        onClick={() => onClick({ folders: true })}
      >
        {t('dashboard.folders.title')}
      </div>
      {!isHideTeam && (
        <div
          ref={teamsTabRef}
          tabIndex={0}
          className={cx(styles.tab, { [styles.tabActive]: state?.team })}
          onClick={() => onClick({ team: true })}
        >
          {t('dashboard.tab.team')}
        </div>
      )}
    </div>
  );
};

export default Tabs;
